export default (state, actions) => {
    return Object.assign({}, state, { timestamp: 1, authorize: true });
};